import { ArpIssuedItemModelDto, ArpParseResultsModelDto } from '@treasury/api/channel';
import { AccountDto, AuditItemDto, IssuedItemEntryType, IssuedItemType } from '../../types/arp';
import { IIssuedItem, IssuedItemPendingStatus, createIssuedItem } from './issued-items.mappings';

/**
 * Maps ArpParseResultsModelDto from the processFile API to IIssuedItem array
 * for use in the issued items creation workflow.
 */
export function mapArpParseResultsToIssuedItems(
    parseResults: ArpParseResultsModelDto
): IIssuedItem[] {
    if (!parseResults?.issuedItems) {
        return [];
    }

    return parseResults.issuedItems.map((item: ArpIssuedItemModelDto) => {
        // Create a new issued item using the factory function
        const issuedItem = createIssuedItem();

        // Map the properties from ArpIssuedItemModelDto to IIssuedItem
        issuedItem.itemEntryType = (item.entryType as IssuedItemEntryType) || 'Transmitted';
        issuedItem.createdDate = item.createdDate ? new Date(item.createdDate) : new Date();
        issuedItem.dateIssued = item.dateIssued ? new Date(item.dateIssued) : undefined;
        issuedItem.voidedDate = item.voidDate ? new Date(item.voidDate) : undefined;
        issuedItem.postDate = item.postDate ? new Date(item.postDate) : undefined;
        // Map audit items with proper type conversion
        issuedItem.auditItems = (item.auditItems || []).map(auditItem => ({
            ...auditItem,
            createdByUserName: auditItem.createdByUserName || '',
        })) as AuditItemDto[];
        issuedItem.checkAmount = item.checkAmount || 0;
        issuedItem.checkNumber = item.checkNumber || undefined;
        issuedItem.payee = item.payee || '';
        // Map itemStatus to valid enum value or empty string
        issuedItem.itemStatus =
            item.itemStatus === 'Issued' ||
            item.itemStatus === 'Cleared' ||
            item.itemStatus === 'Returned' ||
            item.itemStatus === 'Void' ||
            item.itemStatus === 'Deleted' ||
            item.itemStatus === 'StopPay' ||
            item.itemStatus === 'StaleDate' ||
            item.itemStatus === 'Dormant' ||
            item.itemStatus === 'Failed' ||
            item.itemStatus === 'Submitted'
                ? item.itemStatus
                : '';
        issuedItem.type = (item.type as IssuedItemType) || 'Check';
        // Convert CompanyAccountModelDto to AccountDto structure
        issuedItem.account = item.account
            ? ({
                  ...item.account,
                  availableBalanceFormatted: '',
                  collectedBalanceFormatted: '',
                  currentBalanceFormatted: '',
              } as unknown as AccountDto)
            : undefined;
        issuedItem.pendingStatus = IssuedItemPendingStatus.None;

        return issuedItem;
    });
}
